export const JOURNEY_STATUS_TYPES = {
    ACTIVE: 'Active',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
} as const;

export type JourneyStatusType = (typeof JOURNEY_STATUS_TYPES)[keyof typeof JOURNEY_STATUS_TYPES];
